<div class="button-ai-chatbot-container z-999" *ngIf="enableChatBoxAI">
    <button style="box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" class="flex items-center" color="primary"
        mat-flat-button (click)="openDialogPopupAI()">
        <span>{{isOpenPopup ? ('CONTROL.CLOSE' | transloco) : ('BUTTON.AI_CHATBOT.LABEL' | transloco)}}</span>
        <mat-icon class="ml-1" [svgIcon]="isOpenPopup ? 'ic_close' : 'ic_message'  "></mat-icon>
    </button>
</div>